module.exports = __webpack_public_path__ + "img/SCADA PP Line B.e4405c96.jpg";